import { FormField, FormRow, Input, Select } from '../../ui';
import { SearchableSelect } from '../../ui/SearchableSelect';
import { CLUSTERING_COUNTRY_OPTIONS } from '../../../constants/clusteringCountries';
import type { BatchConfig } from '../../../types/clustering';

interface BatchConfigFormProps {
  value: BatchConfig;
  onChange: (next: BatchConfig) => void;
  disabled?: boolean;
}

export function BatchConfigForm({ value, onChange, disabled }: BatchConfigFormProps) {
  const set = <K extends keyof BatchConfig>(key: K, val: BatchConfig[K]) =>
    onChange({ ...value, [key]: val });

  return (
    <div>
      <FormRow>
        <SearchableSelect
          options={CLUSTERING_COUNTRY_OPTIONS.map((c) => ({ value: c.value, label: c.label, prefix: c.flag }))}
          value={value.country}
          onChange={(v) => set('country', v)}
          label="Country"
          placeholder="Select country…"
          disabled={disabled}
          required
        />
        <FormField label="Target domain (optional)" htmlFor="cfg-target-domain">
          <Input
            id="cfg-target-domain"
            type="url"
            placeholder="example.com"
            value={value.target_domain ?? ''}
            onChange={(e) => set('target_domain', e.target.value || null)}
            disabled={disabled}
            fullWidth
          />
        </FormField>
      </FormRow>

      <FormRow>
        <FormField
          label="SERP overlap threshold (2–10)"
          htmlFor="cfg-threshold"
          helpText="Minimum shared top-N URLs between keywords to link them."
        >
          <Select
            id="cfg-threshold"
            value={value.threshold}
            onChange={(e) => set('threshold', Number(e.target.value))}
            disabled={disabled}
            fullWidth
          >
            {Array.from({ length: 9 }, (_, i) => i + 2).map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </Select>
        </FormField>

        <FormField
          label="SERP depth (5–20)"
          htmlFor="cfg-depth"
          helpText="How many top results per keyword to fetch."
        >
          <Input
            id="cfg-depth"
            type="number"
            min={5}
            max={20}
            value={value.depth}
            onChange={(e) => set('depth', Number(e.target.value) || 10)}
            disabled={disabled}
            fullWidth
          />
        </FormField>
      </FormRow>
    </div>
  );
}
